import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';

import { environment } from '@env/environment';
import { RouteReusableStrategy, ErrorHandlerInterceptor, SharedModule } from '@shared';
import { HomeModule } from './home/home.module';
import { ShellModule } from './shell/shell.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ProjectFilesModule } from './project-files/project-files.module';
import { AnalyticsModule } from './analytics/analytics.module';
import { AlleleUsageModule } from './allele-usage/allele-usage.module';
import { GeneAnalyticsModule } from './gene-analytics/gene-analytics.module';
import { AuthModule } from './auth/auth.module';
import { AuthInterceptor } from './@shared/http/auth.interceptor';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { FlairrStatsModule } from './flairr-stats/flairr-stats.module';
import { FlairrSummaryModule } from './flairr-summary/flairr-summary.module';
import { GeneStatsModule } from './gene-stats/gene-stats.module';
import { GeneSummaryModule } from './gene-summary/gene-summary.module';
import { provideRouter } from '@angular/router';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import * as PlotlyJS from 'plotly.js-dist-min';
import { PlotlyModule } from 'angular-plotly.js';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    ServiceWorkerModule.register('./ngsw-worker.js', { enabled: environment.production }),
    FormsModule,
    RouterModule,
    BrowserAnimationsModule,
    SharedModule,
    ShellModule,
    HomeModule,
    ProjectFilesModule,
    AmplifyAuthenticatorModule,
    AnalyticsModule,
    AlleleUsageModule,
    GeneAnalyticsModule,
    FlairrStatsModule,
    FlairrSummaryModule,
    GeneStatsModule,
    GeneSummaryModule,
    BsDropdownModule,
    PlotlyModule.forRoot(PlotlyJS),
    AuthModule, // let these two come last !!
    AppRoutingModule,
  ],
  providers: [
    provideCharts(withDefaultRegisterables()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    {
      provide: RouteReuseStrategy,
      useClass: RouteReusableStrategy,
    },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class AppModule {}
